import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'blog-post-preview',
  templateUrl: './blog-post-preview.component.html',
  styleUrls: ['./blog-post-preview.component.scss']
})
export class BlogPostPreviewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
